import styled from "styled-components";
import { Input } from "../../../../../../Components/Input";

export const InputTable = styled(Input)`
  border: none;
  text-align: center;
  border-radius: 0;
`;
